<div
  class="is-fullwidth is-flex is-justify-content-center is-align-items-center home"
>
  <h1 class="title" data-testid="title">Willkommen im KWH Courier</h1>
</div>
